module.exports = __webpack_public_path__ + "assets_1773798366357/img/guide_ios.431fc979.png";